const action = fun => {
  try {
    return fun()
  } catch(e) { // eslint-disable-line
    return null
  }
}
export const setItem = (key, value) => action(() => globalThis.localStorage.setItem(key, value))
export const getItem = key => action(() => globalThis.localStorage.getItem(key))
export const removeItem = key => action(() => globalThis.localStorage.removeItem(key))
export const clear = () => action(() => globalThis.localStorage.clear())
